import thunk from 'redux-thunk';
import logger from 'redux-logger';
import {configureStore} from "@reduxjs/toolkit";
import UIReducer from "../reducers/UIReducer";

export const configureReduxStore = () => {

    let store;

    if (process.env.REACT_APP_CUSTOM_NODE_ENV === 'staging') {
        store = configureStore({
            reducer: {
                UIReducer: UIReducer,
            },
            middleware: [thunk, logger]
        });
    } else if (process.env.NODE_ENV === 'production') {
        store = configureStore({
            reducer: {
                UIReducer: UIReducer,
            },
            middleware: [thunk]
        });
    } else {
        //If we are running tests disable the logger - I don't like that the code is aware of the test suite, but directly using the store for
        //tests gives us great insight into the actual working functionality without having to duplicate tons of code for mocks
        if (process.env.JEST_WORKER_ID !== undefined) {
            store = configureStore({
                reducer: {
                    UIReducer: UIReducer,
                },
                middleware: [thunk]
            });
        } else {
            store = configureStore({
                reducer: {
                    UIReducer: UIReducer,
                },
                middleware: [thunk, logger]
            });
        }
    }

    return store;
}

export const store = configureReduxStore();
